import React, { Component } from "react";
import { connect } from "react-redux";
import { getData2 } from './actions'
import BlockUi from 'react-block-ui';
import { Line } from 'react-chartjs-2';

class Chart2 extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    var requestData = {
      tu_ngay: this.props.tu_ngay,
      den_ngay: this.props.den_ngay,
      store_id: this.props.store_id,
      type: this.props.type
    }
    this.props.getData2(requestData)
  }

  render() {
    const {
      requesting,
      data2
    } = this.props
    return (
      <BlockUi tag="div" blocking={requesting} className="w-100">
        <Line
          data={data2}
          width={50}
          height={500}
          options={{
            maintainAspectRatio: false,
            title: {
              display: true,
              text: this.props.title || 'Doanh số bán',
              fontSize: 25,
              fontColor: "#07a7e3",
              fontStyle: "normal"
            },
            legend: {
              display: true,
              position: 'top'
            },
            scales: {
              yAxes: [{
                ticks: {
                  callback: function (label, index, labels) {
                    return label.toLocaleString(navigator.language, { minimumFractionDigits: 0 });
                  }
                }
              }]
            },
            tooltips: {
              callbacks: {
                label: function (tooltipItem, data) {
                  tooltipItem.yLabel = tooltipItem.yLabel.toLocaleString(navigator.language, { minimumFractionDigits: 0 });
                  return tooltipItem.yLabel;
                }
              }
            }
          }}
        />
      </BlockUi>
    )
  }
}
const dataChart2 = {
  labels: [],
  datasets: [
    {
      label: 'Tiền',
      data: [0, 0],
    }
  ]
}
const mapStateToProps = state => ({
  data2: state.chart2.data2 || dataChart2,
  requesting: state.chart2.requesting,
  successful: state.chart2.successful,
});

const connected = connect(
  mapStateToProps,
  {
    getData2: getData2
  }
)(Chart2);

export default connected


// WEBPACK FOOTER //
// ./src/components/Chart2/Chart2.js